import { createRoute } from "@tanstack/react-router";

import { ReviewsContent } from "../components/screens/ReviewsContent";
import { rootRoute } from "./__root";

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/reviews",
  component: ReviewsContent,
});
